export const MAIN_CLASS_NAME = 'project-source-modal';
export const TITLE_CLASS_NAME = `${MAIN_CLASS_NAME}__title`;
export const RADIO_GROUP_CLASS_NAME = `${MAIN_CLASS_NAME}__radio-group`;
export const RADIO_BUTTON_CLASS_NAME = `${RADIO_GROUP_CLASS_NAME}__button`;
export const RADIO_BUTTON_LABEL_CLASS_NAME = `${RADIO_BUTTON_CLASS_NAME}__label`;

export const CONFLUENCE_DEFAULT_CONTENT_SELECTOR = 'body';
export const CONFLUENCE_DEFAULT_FILTER_SELECTOR = '.recently-updated, .labelsAlphaList';
